<template>
  <div style="color: #fff" class="rightBar">
    <v-drawer :direction="'right'" :width="'26%'">
      <div class="animated fadeInRightBig" style="height: 100%; width: 100%">
        <div class="panel margin--bottom">
          <bar-card :bg="'border10'">
            <v-title :title="graphic.name"
              >{{ graphic.name | ellipsis }}
            </v-title>
            <div class="content">
              <div class="closeDraw">
                <el-button icon="el-icon-close" @click="closeClick"></el-button>
              </div>
              <div class="tabPanel">
                <img class="img" v-if="imgTp" v-lazy="imgTp" align="right" />
                <div class="info">{{ graphic.jdjs || graphic.qyjs }}</div>
              </div>
            </div>
            <v-title>面积/产值变化</v-title>
            <div class="area-content">
              <div class="tab-box flex">
                <div
                  v-for="(item, index) in typeList"
                  :key="index"
                  class="tab-item"
                  :class="{ active: active === index }"
                  @click="changeType(index)"
                >
                  <span>{{ item }}</span>
                </div>
              </div>
              <div class="chart" ref="chart"></div>
            </div>
            <v-title>基地风采</v-title>
            <div class="spContent">
              <div class="img-box" v-if="swiperList2.length > 0">
                <swiper :options="swiperOptionjk" class="imgcasesT">
                  <swiper-slide
                    v-for="(it, i) in swiperList2"
                    :key="it"
                    class="swiper-slides"
                  >
                    <div class="s-logo" @click="jdclick(i)">
                      <img :src="it" alt="" />
                      <!-- <div class="s-title">荔枝0{{ it }}</div> -->
                    </div>
                  </swiper-slide>
                </swiper>
                <div
                  class="swiper-button-next swiper-button-next-jdfc"
                  slot="button-next"
                ></div>
                <div
                  class="swiper-button-prev swiper-button-prev-jdfc"
                  slot="button-prev"
                ></div>
              </div>
              <div class="no-img" v-else>暂无基地照片</div>
            </div>
          </bar-card>
        </div>
      </div>
    </v-drawer>

    <image-preview
      :show.sync="imgpre"
      :list="swiperList2"
      :initialIndex="initialIndex"
    ></image-preview>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { loadLineChart } from "./charts/lineChart";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
const imagePreview = () => import("@/components/imagePreview");
import "swiper/dist/css/swiper.css";
export default {
  components: {
    Swiper,
    SwiperSlide,
    imagePreview,
  },
  filters: {
    ellipsis(value) {
      if (!value) return "";
      if (value.length > 9) {
        return value.slice(0, 9) + "...";
      }
      return value;
    },
  },
  data() {
    return {
      activeName: "first",
      list: [],
      weather: [],
      sbList: [],
      imgTp: "",
      typeList: ["面积", "产值"],
      active: 0,
      swiperList: [],
      swiperOptionjk: {
        autoplay: true,
        slidesPerView: 2, //设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
        spaceBetween: 20,
        loop: true, // 循环轮播
        navigation: {
          nextEl: ".swiper-button-next-jdfc",
          prevEl: ".swiper-button-prev-jdfc",
        },
        speed: 300,
      },
      imgpre: false,
      initialIndex: 0,
    };
  },
  computed: {
    ...mapGetters(["graphic"]),
    swiperList2() {
      let arr = [];
      if (this.graphic) {
        if (this.graphic.orgCompanyFiles) {
          if (
            this.graphic.orgCompanyFiles instanceof Array &&
            this.graphic.orgCompanyFiles.length > 0
          ) {
            this.graphic.orgCompanyFiles.forEach((e) => {
              if (e.address) {
                arr.push(window.__config.VUE_APP_IMG_URL + e.address);
              }
            });
          }
        }
      }
      return arr;
    },
  },
  mounted() {
    this.$bus.$on("yzjdContent", (val) => {
      if (val.dpimage) {
        this.imgTp = require("images/index/map/" + val.dpimage);
      }
    });
    this.initCharts();
  },
  methods: {
    jdclick(i) {
      this.initialIndex = i;
      this.imgpre = true;
    },
    closeClick() {
      // 获取缓存rightcomponent
      let rightcomp = sessionStorage.getItem("rightComponent") || "rightDrawer";
      //   this.$store.dispatch("drawer/setRightComponent", "zzjdDrawer");
      this.$store.dispatch("drawer/setRightComponent", rightcomp);
      this.$store.dispatch("drawer/setGraphic", null);
    },
    initCharts() {
      this.chart = this.$echarts.init(this.$refs.chart);
      // 种植面积年度变化-折线图
      if (this.active === 0) {
        const yearlist = ["2017", "2018", "2019", "2020", "2021"];
        let bflist = [100, 160, 270, 220, 390];
        const bfData = [bflist];
        const unit = "亩";
        loadLineChart(this.chart, yearlist, bfData, unit);
      } else {
        const yearlist = ["2017", "2018", "2019", "2020", "2021"];
        let bflist = [100, 140, 220, 260, 390];
        const bfData = [bflist];
        const unit = "万元";
        loadLineChart(this.chart, yearlist, bfData, unit);
      }
    },
    changeType(index) {
      this.active = index;
      this.initCharts();
    },
  },
  destroyed() {
    this.$store.dispatch("drawer/setGraphic", null);
    this.$bus.$off("yzjdContent");
  },
};
</script>

<style lang="stylus" scoped>
.panel
  height calc(100% - 8px)
  width 100%
  font-size 0.06rem
.content
  height calc(35% - 43px)
  width calc(100% - 20px)
  padding 0 10px
  position relative
.area-content
  height calc(33% - 43px)
  width calc(100% - 20px)
  padding 0 10px
  position relative
  .chart
    height 100%
.spContent
  height calc(32% - 43px)
  width calc(100% - 20px)
  padding 10px
  position relative
  .no-img
    font-size 20px
    font-weight bold
    text-align center
    color #aaa
    margin-top 18%
.closeDraw
  position absolute
  right 10px
  top -30px
  .el-button
    background transparent
    color #fff
    font-size 25px
    padding 0
    border 0
    position relative
.warn
  padding 0
  background transparent
  border 0
  color #fff
  font-size 0.18rem
  &:hover
    background transparent
    color #fff
p
  text-indent 28px
  line-height 20px
  font-size 13px
  letter-spacing 2px
.tabPanel
  height calc(100% - 0px)
  width calc(100% - 0px)
  overflow-y auto
  .img
    height 150px
    border-radius 10px
    padding-left 5px
  .info
    text-indent 2em
    line-height 22px
    letter-spacing 2px
    color #fff !important
    width 100%
    height 100%
    padding 10px
    box-sizing border-box
  &::-webkit-scrollbar
    width 4px
    background-color #00162D
  /* 定义滚动条轨道 内阴影+圆角 */
  &::-webkit-scrollbar-track
    -webkit-box-shadow inset 0 0 6px transparent
    background-color transparent
  /* 定义滑块 内阴影+圆角 */
  &::-webkit-scrollbar-thumb
    border-radius 10px
    -webkit-box-shadow inset 0 0 6px transparent
    background-color #0ff
  /* 定义最上方和最下方的按钮 */
  &::-webkit-scrollbar-button
    height 0
@media (min-width 1700px)
  .el-timeline
    height 80vh
@media (min-height 1400px)
  .content
    height calc(100% - 79px)
  .rightBar
    >>>.side
      width 24% !important
  .closeDraw
    top -60px
    right 20px
    .el-button
      font-size 40px
.imgs
  height calc(100% - 0px)
  width 100%
  justify-content center
.dddd
  width calc(100% - 2px) !important
  height calc(100% - 2px) !important
  object-fit fill
  border 1px #31d5f3 solid
.videobox
  height 100%
  width calc(100% - 0px)
  border-radius 10px
@media (max-width 1280px)
  .content
    height calc(60% - 25px)
  .closeDraw
    top -20px
    .el-button
      font-size 15px
  .tabPanel
    &::-webkit-scrollbar
      width 2px
    .img
      height 75px
      padding-left 3px
    .info
      text-indent 2em
      line-height 16px
      letter-spacing 2px
      font-size 0.08rem
  .spContent
    height calc(40% - 30px)
.tab-box
  position absolute
  top 14px
  right 4%
  z-index 999
  .tab-item
    color #fff
    font-size 10px
    padding-left 13px
    margin-right 20px
    position relative
    cursor pointer
    &:before
      content ' '
      // width 6px
      // height 6px
      width 12px
      height 12px
      border-radius 50%
      background #fff
      position absolute
      left 0
      top 50%
      transform translateY(-50%)
  .active
    color #0e9cff
    &:before
      background #0e9cff
.swiper-button-prev-jdfc
    background url('~images/index/szjc/left.png') center no-repeat
    background-size 100% 100%
.swiper-button-next-jdfc
    background url('~images/index/szjc/right.png') center no-repeat
    background-size 100% 100%
.swiper-button-prev:after, .swiper-button-next:after
    display none
.imgcasesT
    margin 0 10px
    height 100%
    .s-logo
        background url('~images/gdq-bg.png') no-repeat center center
        background-size 100% 100%
        padding 6px 10px
        overflow hidden
        max-height 200px
        height calc(100% - 12px)
        position relative
        cursor pointer
        img
            width 100%
            height 200px
            object-fit cover
    .s-title
        color white
        text-align center
        position absolute
        bottom 0
        left 0
        right 0
        height 22px
        line-height 22px
        background #00000066
    // .s-v-logo
    //     width 140px
    //     height 80px

.el-carousel
  height 100%

  >>>.el-carousel__mask
    background rgba(0, 0, 0, 0)

  >>>.el-carousel--horizontal
    overflow hidden

  >>>.el-carousel__container
    height 100%
</style>
<style>
.video-js.vjs-fluid,
.video-js.vjs-16-9,
.video-js.vjs-4-3 {
  height: 100% !important;
  padding-top: 0 !important;
  width: 100% !important;
}
.vjs-tech {
  width: 100% !important;
  height: 100% !important;
}
.vjs-poster {
  background-position: center !important;
  background-size: cover !important;
}

video {
  width: calc(100% - 0px) !important;
  height: calc(100% - 0px) !important;
}
</style>
